import { useContext, useCallback } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import index from "@beeldit/core/services";
import { ListActionContext } from "@beeldit/core/actions/list/ListActionContext";

function useIndex(modelConfig: any) {
  const { tableFilters, orderBy, setTableData } = useContext(ListActionContext);
  const errorHandler = useErrorHandler();

  return useCallback(() => {
    // Usar los filtros del contexto directamente
    const currentFilters = { ...tableFilters };

    if (modelConfig.indexQueryParams) {
      for (let [key, value] of Object.entries(modelConfig.indexQueryParams)) {
        if (Array.isArray(value)) {
          value = value.join(",");
        }
        currentFilters[key] = value;
      }
    }
    let filterPath = "z";
    if (currentFilters) {
      for (const [key, value] of Object.entries(currentFilters)) {
        if (value) {
          filterPath += `&${key}=${value}`;
        }
      }
    }
    if (orderBy) {
      filterPath += `&orderBy=${orderBy}`;
    }
    index(modelConfig.endpoint, filterPath)
      .then((response: any) => {
        setTableData(response.data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  }, [tableFilters, orderBy, setTableData, errorHandler, modelConfig.endpoint, modelConfig.indexQueryParams]);
}

export default useIndex;
